import { onReady } from "../../utils/events/onReady";
import Swiper from "../../../node_modules/swiper/swiper-bundle.js";
import MouseFollower from "mouse-follower";
import gsap from "gsap";
import aos from "aos";

export class ArticlesTeaser {
    data = {};
    dom = {
        container: undefined
    };

    /**
     *
     * @param {Element} container - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;

        onReady(() => this.init(this.dom.container));
        window.onorientationchange = () => {
            this.init(this.dom.container);
        };
    }

    init() {
        aos.init();

        const swiper = new Swiper(`[id='${this.dom.container.id}'] .swiper`, {
            direction: "horizontal",
            slidesPerView: "4",
            allowTouchMove: true,
            navigation: {
                prevEl: `[id='${this.dom.container.id}'] .left-overlay`,
                nextEl: `[id='${this.dom.container.id}'] .right-overlay`
            },
            pagination: {
                el: `[id='${this.dom.container.id}'] .swiper-pagination-articles`,
                type: "bullets",
                clickable: true
            },
            wrapperClass: "swiper-wrapper",
            effect: "slide",
            speed: 600,
            breakpoints: {
                320: {
                    slidesPerView: 1.15,
                    centeredSlides: true,
                    centeredSlidesBounds: true
                },
                480: {
                    slidesPerView: 1.15,
                    centeredSlides: true,
                    centeredSlidesBounds: true
                },
                640: {
                    slidesPerView: 1.15,
                    centeredSlides: true,
                    centeredSlidesBounds: true
                },
                768: {
                    slidesPerView: 1.15,
                    centeredSlides: true,
                    centeredSlidesBounds: true
                },
                992: {
                    slidesPerView: 4
                }
            }
        });
        const articleCards = this.dom.container.querySelectorAll(
            ".col--md-3.swiper-slide"
        );

        if (window.matchMedia("(min-width: 992px)").matches) {
            MouseFollower.registerGSAP(gsap);
            const cursor = new MouseFollower({
                container: this.dom.container,
                speed: 0.3,
                className: "articles-cursor",
                stateDetection: {
                    "-left": ".left-overlay",
                    "-left-disabled": ".left-overlay.swiper-button-disabled",
                    "-right": ".right-overlay",
                    "-right-disabled": ".right-overlay.swiper-button-disabled",
                    "-pointer": ".link-articles-teaser",
                    "-hidden": ".row.articles-teaser__title-container",
                    "-hidden": ".swiper-pagination-articles",
                    "-visible": ".row.article"
                }
            });
        }
    }
}
